import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ja from './locales/ja.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

export const SUPPORTED_LOCALES = ['en', 'ja', 'es', 'de', 'fr'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_META: Record<SupportedLocale, { label: string; flag: string; nativeLabel: string }> = {
  en: { label: 'English', flag: '🇬🇧', nativeLabel: 'English' },
  ja: { label: 'Japanese', flag: '🇯🇵', nativeLabel: '日本語' },
  es: { label: 'Spanish', flag: '🇲🇽', nativeLabel: 'Español' },
  de: { label: 'German', flag: '🇩🇪', nativeLabel: 'Deutsch' },
  fr: { label: 'French', flag: '🇫🇷', nativeLabel: 'Français' },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
      es: { translation: es },
      de: { translation: de },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
